<template>
    <RingLoader />
    <UIDialog v-if="ui.getDialog" />
    <router-view />
</template>

<script lang="ts">
    import { defineComponent, ref } from "vue";
    import RingLoader from "./components/ui/loader/RingLoader.vue";
    import { useUI } from "./store/ui";
    import { useUsers } from "./store/users";
    import { useNodes } from "./store/nodes";
    import UIDialog from "./components/ui/UIDialog/UIDialog.vue";
    import initWS from "@/websocket";

    export default defineComponent({

        setup() {
            return {
                ui: useUI(),
                users: useUsers(),
                nodes: useNodes(),
                WS: ref(null),
                WSmessages: ref([]),
            } as any;
        },

        components: {
            RingLoader,
            UIDialog
        },

        // computed: {
        //     currentFolder(): number | null
        //     {
        //         console.log(this.$route.query, 'dfdf');
        //         if (typeof this.$route.query.folder !== 'string') return null;
        //         if (isNaN(parseInt(this.$route.query.folder))) return null;
        //         return parseInt(this.$route.query.folder);
        //     },
        // },
        
        methods: {
            async loadInitialData(folder: number | null) {

                // console.log(this.$route.fullPath, 'fp ');

                this.ui.ringLoader = true;
                await this.users.fetch();
                // await this.nodes.fetch(folder);
                this.ui.ringLoader = false;

                // console.log(this.nodes.all, 'NODES')
            }
        },

        watch: {
            // '$route.query.folder': {
            //     handler(value) {
            //         // console.log('whatch', value);
            //         if (localStorage.token) this.loadInitialData(isNaN(parseInt(value)) ? null : parseInt(value));
            //     },
            //     immediate: true
            // },

            // '$route.fullPath': {
            //     handler(value) {
            //         console.log(this.$route.fullPath, 'fp 2', value);
            //         // if (localStorage.token) this.loadInitialData(isNaN(parseInt(value)) ? null : parseInt(value));
            //     }
            // }
        },

        // async beforeMount() {
        //     if (localStorage.token) this.loadInitialData();
        // },

        mounted() {

            this.WS = initWS();

            if (localStorage.token) this.loadInitialData(null);

            this.ui.innerHeight = window.innerHeight;
            this.ui.innerWidth = window.innerWidth;

            window.addEventListener('resize', () => {
                this.ui.innerHeight = window.innerHeight;
                this.ui.innerWidth = window.innerWidth;
            });
            
        },

        unmounted() {
            if (this.WS && this.WS.value) {
                this.WS.value.close();
            }
        }

    });

</script>

<style>

</style>
